import AdminView from "@/views/admin/AdminView.vue";
import { RouteConfig } from "vue-router";

const adminRouter: Array<RouteConfig> = [
    {
        path: "/administrar",
        name: "Painel Administrativo",
        component: AdminView,
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        props: (route) => ({ painel: route.query.painel }),
        children: [
            {
                path: "pedidos",
                alias: "",
                name: "Pedidos",
                component: () => import("@/views/admin/pedidos/PedidosView.vue"),
            },
            {
                path: "produtos",
                name: "Produtos",
                component: () => import("@/views/admin/produtos/ProdutosView.vue"),
            },
            {
                path: "grupos_produtos",
                name: "Grupos de Produtos",
                component: () => import("@/views/admin/grupoProdutos/GrupoProdutosView.vue"),
            },
            {
                path: "perfil_usuarios",
                name: "Perfil de Usuários",
                component: () => import("@/views/admin/perfil/PerfilUsuariosAdmin.vue"),
            },
            {
                path: "usuarios",
                name: "Usuários",
                component: () => import("@/views/admin/usuarios/UsuariosView.vue"),
            },
            {
                path: "gerais",
                name: "Gerais",
                component: () => import("@/views/admin/configGeral/AppConfigView.vue"),
            },
            {
                path: "comercial",
                name: "Comercial",
                component: () => import("@/views/admin/comercial/comercial.vue"),
            },
            {
                path: "estoque",
                name: "Estoque",
                component: () => import("@/views/admin/estoque/estoque.vue"),
            },
            {
                path: "financeiro",
                name: "Financeiro",
                component: () => import("@/views/admin/financeiro/financeiro.vue"),
            },
            {
                path: "logistica",
                name: "Logística",
                component: () => import("@/views/admin/logistica/logistica.vue"),
            },
            {
                path: "usuarios",
                name: "Administrar Usuários",
            }
        ]
    },
]

export default adminRouter;